import tw, { styled } from 'twin.macro';

import { getVariation } from '../../Banner/Banner.styles';
import { Props } from './Banner';

type StyledBannerProps = Pick<Props, 'variation'>;

export const StyledBanner = styled.div<StyledBannerProps>(({ variation }) => [
	getVariation(variation),
	tw`py-2 flex justify-center font-normal border-t-0 border-l-0 border-r-0`,
]);
